export default __webpack_public_path__ + "static/media/gallery_08.384a2336.jpg";